module.exports = __webpack_public_path__ + "media/images/lp_voice-2-61dc7908ac8c9cdb42e9cbf6954b034b.webp";